module.exports = __webpack_public_path__ + "img/soothsayer.1f83dfdc.png";